import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=f341efda&scoped=true&"
import script from "./Onboard.vue?vue&type=script&lang=js&"
export * from "./Onboard.vue?vue&type=script&lang=js&"
import style0 from "./Onboard.vue?vue&type=style&index=0&id=f341efda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f341efda",
  null
  
)

export default component.exports